import { createContext } from 'react';
var ChromeContext = createContext({
    update: function () { return undefined; },
    setLastVisited: function () { return undefined; },
    setFavoritePages: function () { return undefined; },
    subscribe: function () { return Symbol(0); },
    unsubscribe: function () { return undefined; },
    setIdentity: function () { return undefined; },
    setVisitedBundles: function () { return undefined; },
    getState: function () { return ({
        lastVisitedPages: [],
        subscribtions: {},
        favoritePages: [],
        visitedBundles: {},
        initialized: false,
    }); },
});
export default ChromeContext;
//# sourceMappingURL=ChromeContext.js.map